import { SOURCE_TYPE_ICONS } from '../constants';
import { Box } from 'lucide-react';

interface SourceTypeIconProps {
  type: string;
  className?: string;
}

export function SourceTypeIcon({ type, className = 'size-4' }: SourceTypeIconProps) {
  const Icon = SOURCE_TYPE_ICONS[type] || Box;

  return <Icon className={className} />;
}
